import React, { useState } from 'react';
import NextBtn from "../../partial/NextBtn";
import StyleWelcomeView from "./styles/StyleWelcomeView";
import ReactHtmlParser from "react-html-parser";
import { useRecoilValue } from "recoil";
import withUrlParams from "../../HOC/withUrlParams";
import { isOnlineState } from "../../../states/states";
import CustomSweetAlert from "../../helper/CustomSweetAlert";
import TestInfoDetail from "./TestInfoDetail";
import i18n from 'i18next';
import { useHistory } from "react-router-dom";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

const WelcomeView = props => {
    const { onStartTest, testInfo, testCode, lessonCode, uuid, currCode } = props;
    const [showSweetWarning, setShowSweetWarning] = useState(false);
    const classes = StyleWelcomeView();
    const keyCountdownLsg = `timeCountdown${testCode ? `test${testCode}` : `lesson${lessonCode}`}`;
    const timeStorage = localStorage.getItem(keyCountdownLsg);
    const isOnline = useRecoilValue(isOnlineState);
    let history = useHistory();

    const startQuiz = () => {
        if (timeStorage) {
            setShowSweetWarning(true);
        } else {
            handleStartQuiz()
        }
    };

    const back = () => {
        isOnline && history.push(`/my-lessons?uuid=${uuid}&curr_code=${currCode}`)
    };

    const handleStartQuiz = () => {
        isOnline && onStartTest();
    };

    return (
        <React.Fragment>
            <div className={classes.welcomeView}>
                <div className={classes.imageWelcome}>
                    <img src={
                        testCode && (testInfo.testTypeId === 5 || testInfo.testTypeId === 6) ?
                            require('../../../assets/images/start_khaosat_binhchon.png') :

                            (
                                (testCode == 1531 || testCode == 1468 || testCode == 1936 || testCode == 1915) ?
                                    require('../../../assets/images/doan_doi.png') :
                                    require('../../../assets/images/img_time.png')
                            )
  
                            
                    } alt="Test" className="center"
                        style={{ width: 230, height: 230 }} />
                </div>

                <div className={classes.currentQuizWelcome}>
                    <TestInfoDetail testInfo={testInfo} />
                </div>

                <div className="area-button" onClick={startQuiz}>
                    <NextBtn>{i18n.t('start')}</NextBtn>
                </div>
                {lessonCode
                    ? <div className="area-button button-back-lesson" onClick={back}>
                        <NextBtn><ArrowBackIosIcon /> {i18n.t('back_lesson')}</NextBtn>
                    </div> : ""
                }

                
                {/* check gia tri cua description */}
                {
                    testInfo.description ? (
                        <div style={{ marginTop: '10px' }}>
                            {testCode && testInfo.testTypeId === 1 ? <b>{i18n.t('test_info')}: </b>
                                : testCode && testInfo.testTypeId === 2 ? <b>{i18n.t('practice_info')}: </b>
                                    : testCode && testInfo.testTypeId === 3 ? <b>{i18n.t('exam_info')}:</b>
                                        : testCode && lessonCode && (testInfo.lessonTypeId === 1 || testInfo.lessonTypeId === 3) ?
                                            <b>{i18n.t('test_info')}:</b>
                                            : lessonCode && testInfo.lessonTypeId === 2 ? <b>{i18n.t('lesson_info')}:</b> : null

                            }
                            {ReactHtmlParser(testInfo.description)}
                        </div>
                    ) : ""
                }
            </div>
            <CustomSweetAlert
                show={showSweetWarning}
                text={i18n.t('logged_out')}
                confirmBtnText={i18n.t('continue_wc')}
                onConfirm={() => {
                    setShowSweetWarning(false);
                    handleStartQuiz();
                }}
                onCancel={() => {
                    setShowSweetWarning(false);
                }}
            />
        </React.Fragment>

    );
};

export default withUrlParams(WelcomeView);
